import React from 'react';
import Select from "../../componentsReusable/Select";
import useAfterUpdateEffect from "../../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

const departments = [
  {
    code: '85',
    city: 'Biała Podlaska',
    street: 'al. Jana Pawła II 128',
  },
  {
    code: '15',
    city: 'Białystok',
    street: 'ul. Elewatorska 29a',
  },
  {
    code: '94',
    city: 'Białystok',
    street: 'ul. 42 Pułku Piechoty 28',
  },
  {
    code: '12',
    city: 'Bielsko-Biała',
    street: 'ul. Podwale 65',
  },
  {
    code: '01',
    city: 'Bieruń',
    street: 'ul. Ekonomiczna 20',
  },
  {
    code: '26',
    city: 'Biesiekierz',
    street: 'ul. Koszalińska 1, Stare Bielice',
  },
  {
    code: '71',
    city: 'Bochnia',
    street: 'ul. Brzeska 123b',
  },
  {
    code: '122',
    city: 'Bolesławiec, Kruszyn',
    street: 'ul. Główna 2d',
  },
  {
    code: '72',
    city: 'Brwinów',
    street: 'ul. Moszna Parcela 29',
  },
  {
    code: '17',
    city: 'Bydgoszcz',
    street: 'ul. Nowotoruńska 20',
  },
  {
    code: '57',
    city: 'Bytom',
    street: 'ul. Arki Bożka 25',
  },
  {
    code: '68',
    city: 'Chełm',
    street: 'ul. Rejowiecka 118/120',
  },
  {
    code: '51',
    city: 'Ciechanów',
    street: 'ul. Płocka 19a',
  },
  {
    code: '52',
    city: 'Częstochowa',
    street: 'ul. Warszawska 315/317',
  },
  {
    code: '13',
    city: 'Dąbrowa Górnicza',
    street: 'ul. Tworzeń 148',
  },
  {
    code: '120',
    city: 'Dąbrówka',
    street: 'ul. Logistyczna 7',
  },
  {
    code: '92',
    city: 'Dębica',
    street: 'ul. Budzisz 73a',
  },
  {
    code: '104',
    city: 'Elbląg',
    street: 'ul. Aleja Grunwaldzka 2',
  },
  {
    code: '116',
    city: 'Ełk',
    street: 'ul. Suwalska 84H',
  },
  {
    code: '59',
    city: 'Garwolin',
    street: 'ul. Ks. kard. S. Wyszyńskiego 7',
  },
  {
    code: '16',
    city: 'Gdańsk',
    street: 'ul. Magnacka 13',
  },
  {
    code: '67',
    city: 'Gdańsk',
    street: 'ul. Piekarnicza 12b',
  },
  {
    code: '115',
    city: 'Gdynia',
    street: 'ul. Pucka 28',
  },
  {
    code: '27',
    city: 'Gliwice',
    street: 'ul. Pszczyńska 206',
  },
  {
    code: '42',
    city: 'Gorzów Wielkopolski',
    street: 'ul. Ryska',
  },
  {
    code: '113',
    city: 'Grudziądz',
    street: 'ul. Składowa 9',
  },
  {
    code: '106',
    city: 'Inowrocław',
    street: 'ul. Mątewska 49',
  },
  {
    code: '90',
    city: 'Jarocin',
    street: 'ul. Szubianki 19',
  },
  {
    code: '123',
    city: 'Jarosław',
    street: 'ul. Sanowa 11',
  },
  {
    code: '93',
    city: 'Jawczyce',
    street: 'ul. Poznańska 74',
  },
  {
    code: '32',
    city: 'Jelenia Góra',
    street: 'ul. Spółdzielcza 35',
  },
  {
    code: '81',
    city: 'Kalisz',
    street: 'ul. Wrocławska 180',
  },
  {
    code: '119',
    city: 'Karczew',
    street: 'ul. Słoneczna 1',
  },
  {
    code: '11',
    city: 'Katowice',
    street: 'ul. Żeliwna 43',
  },
  {
    code: '108',
    city: 'Kędzierzyn-Koźle',
    street: 'ul. Piastowska 26a',
  },
  {
    code: '14',
    city: 'Kielce',
    street: 'ul. Ks. P. Ściegiennego 264',
  },
  {
    code: '134',
    city: 'Kielce 2',
    street: 'ul. Batalionów Chłopskich 71',
  },
  {
    code: '103',
    city: 'Kluczbork',
    street: 'ul. Fabryczna 1a',
  },
  {
    code: '65',
    city: 'Kłodzko',
    street: 'ul. Połabska 3a/2',
  },
  {
    code: '117',
    city: 'Kołobrzeg',
    street: 'ul. Janiska 11',
  },
  {
    code: '28',
    city: 'Konin',
    street: 'ul. Spółdzielców 18a',
  },
  {
    code: '08',
    city: 'Kraków',
    street: 'ul. Półłanki 29g',
  },
  {
    code: '60',
    city: 'Kraków',
    street: 'ul. Makuszyńskiego 17',
  },
  {
    code: '56',
    city: 'Krosno',
    street: 'ul. Pużaka 37',
  },
  {
    code: '128',
    city: 'Kutno',
    street: 'ul. Edwarda Piszka 7',
  },
  {
    code: '133',
    city: 'Legnica',
    street: 'ul. A. Struga 13',
  },
  {
    code: '53',
    city: 'Leszno',
    street: 'ul. Geodetów 9',
  },
  {
    code: '46',
    city: 'Lubin',
    street: 'ul. Miroszowicka 1a',
  },
  {
    code: '03',
    city: 'Lublin',
    street: 'ul. Ceramiczna 1',
  },
  {
    code: '91',
    city: 'Lublin 2',
    street: 'ul. Diamentowa 21A',
  },
  {
    code: '21',
    city: 'Lubliniec',
    street: 'ul. Zwycięstwa 5',
  },
  {
    code: '78',
    city: 'Luboń',
    street: 'ul. Powstańców Wielkopolskich 6',
  },
  {
    code: '131',
    city: 'Łomianki',
    street: 'ul. Stanisława Konarskiego 50',
  },
  {
    code: '63',
    city: 'Łomża',
    street: 'Aleja Legionów 145a',
  },
  {
    code: '49',
    city: 'Łódź',
    street: 'ul. Morgowa 2b',
  },
  {
    code: '58',
    city: 'Łódź',
    street: 'ul. Brzezińska 88',
  },
  {
    code: '07',
    city: 'Łódź 1',
    street: 'ul. Płocka 35/43',
  },
  {
    code: '70',
    city: 'Mielec',
    street: 'ul. Nowa 49',
  },
  {
    code: '22',
    city: 'Mińsk Mazowiecki',
    street: 'ul. Warszawska 243',
  },
  {
    code: '79',
    city: 'Modlniczka',
    street: 'ul. Handlowców 2',
  },
  {
    code: '124',
    city: 'Myślenice',
    street: 'ul. Słowackiego 81a',
  },
  {
    code: '101',
    city: 'Nowa Sól',
    street: 'ul. J. Piłsudskiego 75',
  },
  {
    code: '43',
    city: 'Nowy Sącz',
    street: 'ul. Węgierska 185',
  },
  {
    code: '35',
    city: 'Nowy Targ',
    street: 'ul. Składowa 8c',
  },
  {
    code: '20',
    city: 'Olsztyn',
    street: 'al. J. Piłsudzkiego 72',
  },
  {
    code: '109',
    city: 'Oława',
    street: 'ul. 3 Maja 20-22',
  },
  {
    code: '107',
    city: 'Opole',
    street: 'ul. Wrocławska 110',
  },
  {
    code: '19',
    city: 'Opole',
    street: 'ul. Głogowska 39 (Teren OCL)',
  },
  {
    code: '83',
    city: 'Ostrołęka',
    street: 'ul. Kołobrzeska 1a',
  },
  {
    code: '100',
    city: 'Ostrowiec Świętokrzyski',
    street: 'ul. Graniczna 26',
  },
  {
    code: '41',
    city: 'Ostrów Wielkopolski',
    street: 'ul. Komuny Paryskiej 13',
  },
  {
    code: '48',
    city: 'Piaseczno',
    street: 'ul. Techniczna 2a',
  },
  {
    code: '40',
    city: 'Piła',
    street: 'ul. Rodła 14',
  },
  {
    code: '74',
    city: 'Piotrków Trybunalski',
    street: 'ul. Sulejowska 45',
  },
  {
    code: '31',
    city: 'Płock',
    street: 'ul. Kostrogaj 34',
  },
  {
    code: '06',
    city: 'Poznań',
    street: 'ul. Malwowa 154',
  },
  {
    code: '64',
    city: 'Poznań 2',
    street: 'ul. Strzeszyńska 35/37',
  },
  {
    code: '118',
    city: 'Puławy',
    street: 'ul. Składowa 8',
  },
  {
    code: '55',
    city: 'Racibórz',
    street: 'ul. Kochanowskiego 3',
  },
  {
    code: '47',
    city: 'Radom',
    street: 'ul. Warszawska 35',
  },
  {
    code: '112',
    city: 'Radom 2',
    street: 'ul. Aleja Wojska Polskiego 76',
  },
  {
    code: '127',
    city: 'Radomsko',
    street: 'ul. Krasickiego 11',
  },
  {
    code: '39',
    city: 'Rumia',
    street: 'ul. Jana III Sobieskiego 24',
  },
  {
    code: '09',
    city: 'Rybnik',
    street: 'ul. Chabrowa 21',
  },
  {
    code: '02',
    city: 'Rzeszów',
    street: 'ul. Sikorskiego 106A',
  },
  {
    code: '37',
    city: 'Siedlce',
    street: 'ul. Brzeska 157',
  },
  {
    code: '132',
    city: 'Sieradz',
    street: 'ul. Polskiej Organizacji Wojskowej 141',
  },
  {
    code: '87',
    city: 'Słupsk',
    street: 'ul. Jaracza 25',
  },
  {
    code: '66',
    city: 'Sochaczew',
    street: 'ul. Spartańska 12/14',
  },
  {
    code: '114',
    city: 'Sosnowiec',
    street: 'ul. Kresowa 6',
  },
  {
    code: '88',
    city: 'Stargard',
    street: 'ul. Gdańska 4h',
  },
  {
    code: '97',
    city: 'Swarzędz',
    street: 'ul. Wrzesińska 41',
  },
  {
    code: '18',
    city: 'Szczecin',
    street: 'ul. Pomorska 61-65',
  },
  {
    code: '69',
    city: 'Szczecin',
    street: 'ul. Santocka 42',
  },
  {
    code: '121',
    city: 'Szczecinek',
    street: 'ul. Słowiańska',
  },
  {
    code: '111',
    city: 'Świdnica',
    street: 'ul. Westerplatte 51',
  },
  {
    code: '84',
    city: 'Tarnobrzeg',
    street: 'al. Warszawska 42',
  },
  {
    code: '30',
    city: 'Tarnów',
    street: 'ul. Przemysłowa 10',
  },
  {
    code: '86',
    city: 'Tomaszów Mazowiecki',
    street: 'al. Marszałka J. Piłsudskiego 54',
  },
  {
    code: '29',
    city: 'Toruń',
    street: 'ul. Kanałowa 79-81',
  },
  {
    code: '110',
    city: 'Trzebinia',
    street: 'ul. Lipcowa 56c',
  },
  {
    code: '125',
    city: 'Tychy',
    street: 'ul. Metalowa 3',
  },
  {
    code: '77',
    city: 'Wadowice',
    street: 'ul. Dr. J. Putka 9',
  },
  {
    code: '50',
    city: 'Wałbrzych',
    street: 'ul. Armii Krajowej 5c',
  },
  {
    code: '05',
    city: 'Warszawa',
    street: 'ul. Kosmatki 12',
  },
  {
    code: '54',
    city: 'Warszawa',
    street: 'ul. Kraśnicka 6a',
  },
  {
    code: '10',
    city: 'Warszawa 2 Włochy',
    street: 'ul. Jutrzenki 99/101',
  },
  {
    code: '34',
    city: 'Warszawa Białołęka',
    street: 'ul. Modlińska 246a',
  },
  {
    code: '126',
    city: 'Wieluń',
    street: 'ul. Fabryczna 41',
  },
  {
    code: '61',
    city: 'Wocławek',
    street: 'ul. Kaliska 37',
  },
  {
    code: '75',
    city: 'Wodzisław Śląski',
    street: 'ul. Marklowicka 38',
  },
  {
    code: '102',
    city: 'Wołomin',
    street: 'ul. Szosa Jadowska 59a',
  },
  {
    code: '04',
    city: 'Wrocław',
    street: 'ul. Międzyleska 2/4',
  },
  {
    code: '96',
    city: 'Wrocław',
    street: 'ul. Rogowska 117',
  },
  {
    code: '62',
    city: 'Wrocław 2',
    street: 'ul. Długosza 60',
  },
  {
    code: '82',
    city: 'Wyszków',
    street: 'ul. Świętojańska 175',
  },
  {
    code: '129',
    city: 'Zabrze',
    street: 'ul. Grunwaldzka 15',
  },
  {
    code: '89',
    city: 'Zamość',
    street: 'ul. Lipska 63',
  },
  {
    code: '76',
    city: 'Zawiercie',
    street: 'ul. Myśliwska 100',
  },
  {
    code: '105',
    city: 'Zgierz',
    street: 'ul. Sienkiewicza 20',
  },
  {
    code: '23',
    city: 'Zielona Góra',
    street: 'ul. Dekoracyjna 1f',
  },
  {
    code: '80',
    city: 'Żyrardów',
    street: 'ul. Piękna 15',
  },
]

const AutoPartnerSaDepartamentSelect = props => {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(props.value);

  useAfterUpdateEffect(() => props.onChange(value), [value])

  const getOptions = () => {
    return departments.map(department => ({
      label: `${department.city} (nr ${department.code}), ${department.street}`,
      value: department.code,
    }))
  }

  return <Select
    placeholder={t('common:select.placeholder')}
    options={getOptions()}
    value={value}
    onChange={value => setValue(value)}
  />;
};

AutoPartnerSaDepartamentSelect.propTypes = {

};

export default AutoPartnerSaDepartamentSelect;
